import { usePublicApiClient } from '@guiker/react-framework'
import { PublicApiClient } from '@guiker/real-estate-shared'

export const usePublicRealEstateApiClient = usePublicApiClient(PublicApiClient)
